/* Belilan — Amazon-style hover preview on variant image swatches.
   Hovering a swatch square previews that variant's photo over the main gallery;
   moving away restores it. Selection behavior stays the theme's own. */
(function () {
  if (!window.matchMedia || !window.matchMedia('(hover: hover)').matches) return;

  var style = document.createElement('style');
  style.textContent =
    '.bl-vh-overlay{position:absolute;inset:0;z-index:6;display:none;align-items:center;justify-content:center;}' +
    '.bl-vh-overlay.is-active{display:flex;}' +
    '.bl-vh-overlay img{width:100%;height:100%;object-fit:contain;}' +
    '.m-main-product .m-media-gallery{position:relative;}' +
    '.m-product-option--node__label.has-bg-img[data-option-type="image"]{background-size:contain!important;background-position:center!important;background-repeat:no-repeat!important;background-color:#fff!important;}';
  document.head.appendChild(style);

  var overlay = null;
  var img = null;
  var showTimer = null;
  var suppressKey = null;

  function keyFor(node) {
    return (node.getAttribute('data-option-position') || '') + '|' + (node.getAttribute('data-value') || '');
  }

  function galleryFor(node) {
    var section = node.closest('.m-main-product');
    return section ? section.querySelector('.m-media-gallery') : null;
  }

  function urlFrom(node) {
    var label = node.querySelector('.m-product-option--node__label.has-bg-img');
    if (!label || !label.style.backgroundImage) return null;
    var m = label.style.backgroundImage.match(/url\(["']?([^"')]+)["']?\)/);
    if (!m) return null;
    return m[1].replace(/width=\d+/, 'width=1200');
  }

  function ensureOverlay(gallery) {
    if (overlay && overlay.parentNode === gallery) return;
    if (overlay && overlay.parentNode) overlay.parentNode.removeChild(overlay);
    overlay = document.createElement('div');
    overlay.className = 'bl-vh-overlay';
    var bg = getComputedStyle(gallery).backgroundColor;
    if (!bg || bg === 'rgba(0, 0, 0, 0)') {
      bg = getComputedStyle(document.body).backgroundColor || '#fff';
    }
    overlay.style.background = bg;
    img = document.createElement('img');
    img.alt = '';
    overlay.appendChild(img);
    gallery.appendChild(overlay);
  }

  function hide() {
    if (showTimer) { clearTimeout(showTimer); showTimer = null; }
    if (overlay) overlay.classList.remove('is-active');
  }

  document.addEventListener('mouseover', function (e) {
    if (!e.target || !e.target.closest) return;
    var node = e.target.closest('.m-product-option--node[data-option-type="image"]');
    if (!node) {
      if (suppressKey) suppressKey = null;
      return;
    }
    if (suppressKey) {
      if (keyFor(node) === suppressKey) return;
      suppressKey = null;
    }
    var gallery = galleryFor(node);
    if (!gallery) return;
    var src = urlFrom(node);
    if (!src) return;
    if (showTimer) clearTimeout(showTimer);
    showTimer = setTimeout(function () {
      ensureOverlay(gallery);
      img.src = src;
      overlay.classList.add('is-active');
    }, 60);
  });

  document.addEventListener('mouseout', function (e) {
    if (!e.target || !e.target.closest) return;
    var node = e.target.closest('.m-product-option--node[data-option-type="image"]');
    if (!node) return;
    var to = e.relatedTarget;
    if (to && node.contains(to)) return;
    hide();
  });

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var node = e.target.closest('.m-product-option--node');
    if (!node) return;
    suppressKey = keyFor(node);
    hide();
  }, true);
})();
